import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import { PictureAsPdf } from "components/Icons";
import IColumn from "models/IColumn";
import { downloadDocument } from "helpers/download";
import { markAsRead } from "../app/actions";
import { ROLE_IDS } from "constants/.";
import { URLS } from "constants/urlConstants";
import store from "../../reduxStore";

const renderOrder = ({ OrderId, Order, RoleId }) =>
  _.includes(store.getState().app.roles, "Orders") && Order ? (
    <Link
      className="link"
      to={`${URLS.ORDERS_URL}/${OrderId}?kooptype=${RoleId}`}
    >
      {Order.Number}
    </Link>
  ) : (
    _.get(Order, "Number", "-")
  );

export const columns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    key: "pdf",
    isSortable: false,
    fixedWidth: 52,
    render: rowData => (
      <PictureAsPdf
        id={`download-receipts-returns-${rowData.DocumentId}.pdf`}
        onClick={e => {
          e.stopPropagation();
          downloadDocument(
            rowData,
            () =>
              !_.get(rowData, "Read", true) &&
              markAsRead([rowData.Id], "ReceiptAndReturn")
          );
        }}
      />
    ),
    visible: true
  },
  {
    title: "DELIVERIES_NR",
    fixedWidth: 164,
    key: "ReceiptId",
    visible: true
  },
  {
    title: "PURCHASE_TYPE",
    key: "RoleId",
    visible: true
  },
  {
    title: "DOCUMENT_DATE",
    key: "Date",
    type: "date",
    visible: true
  },
  {
    title: "RECEIPTS_DATE",
    key: "ReceiptDate",
    type: "date",
    visible: true
  },
  {
    title: "COUNTERPARTY_NAME",
    key: "OtherRelation.Name",
    visible: true
  },
  {
    title: "COUNTERPARTY_NR",
    key: "OtherRelation.Number",
    visible: true
  },
  {
    title: "GROWER_NAME",
    key: "Seller.Name",
    visible: false,
    render: rowData =>
      ROLE_IDS[rowData.RoleId] === "Supplier"
        ? _.get(rowData, "Seller.Name", "-")
        : "-"
  },
  {
    title: "GROWER_NR",
    key: "Seller.Number",
    visible: false,
    render: rowData =>
      ROLE_IDS[rowData.RoleId] === "Supplier"
        ? _.get(rowData, "Seller.Name", "-")
        : "-"
  },
  {
    title: "PREFERRED_GROWER_NAME",
    key: "Supplier.Name",
    visible: true
  },
  {
    title: "PREFERRED_GROWER_NR",
    key: "Supplier.Number",
    visible: false
  },
  {
    title: "ORDERS_NUMBER",
    key: "Order.Number",
    render: renderOrder,
    visible: true
  }
];
